import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

export function AssetFormsPlaceholder(props) {
  const { layout } = props;

  switch (layout) {
    case 'assetTitle':
      return (
        <div>
          <ContentLoader viewBox="300 0 500 116" width={300} height={35} {...props}>
            <rect x="28" y="29" rx="0" ry="0" width="258" height="32" />
            <rect x="28" y="71" rx="0" ry="0" width="465" height="32" />
          </ContentLoader>
        </div>
      );

    case 'fetchAsset':
      return (
        <div>
          <ContentLoader
            width={350}
            height={400}
            viewBox="100 100 370 500"
            backgroundColor="#f0f0f0"
            foregroundColor="#dedede"
            {...props}
          >
            <rect x="43" y="304" rx="4" ry="4" width="271" height="9" />
            <rect x="44" y="323" rx="3" ry="3" width="119" height="6" />
            <rect x="42" y="77" rx="10" ry="10" width="388" height="217" />
          </ContentLoader>
        </div>
      );

    case 'fetchFormTemplates':
      return (
        <div>
          <ContentLoader width={400} height={70} {...props}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
        </div>
      );

    case 'fetchForm':
      return (
        <div>
          <ContentLoader width={400} height={70} {...props}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
          <ContentLoader width={400} height={70}>
            <rect x="70" y="15" rx="5" ry="5" width="300" height="15" />
            <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
            <rect x="20" y="10" rx="0" ry="0" width="40" height="40" />
          </ContentLoader>
        </div>
      );

    case 'threedots':
      return (
        <div>
          <ContentLoader viewBox="0 60 400 100" height={60} width={200} backgroundColor="transparent" {...props}>
            <circle cx="150" cy="86" r="8" />
            <circle cx="194" cy="86" r="8" />
            <circle cx="238" cy="86" r="8" />
          </ContentLoader>
        </div>
      );
    default:
      return <div />;
  }
}

AssetFormsPlaceholder.propTypes = {
  layout: PropTypes.string.isRequired,
};

export default AssetFormsPlaceholder;
